import Swiper from "swiper";
import { Navigation } from "swiper/modules";

export default function initQuoteCarousel(): void {
    const $quotesCarouselContainer = document.querySelectorAll('.js-quote-slider');

    $quotesCarouselContainer.forEach($container => {
        new QuotesCarousel($container as HTMLElement);
    });
}

class QuotesCarousel {
    $el: HTMLElement;
    swiper: Swiper | null = null;
    $nextButton: HTMLElement | null = null;
    $prevButton: HTMLElement | null = null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$nextButton = this.$el.querySelector('.js-next-button') as HTMLElement;
        this.$prevButton = this.$el.querySelector('.js-prev-button') as HTMLElement;
        this.init();
        
    }

    init(): void {
        if (this.$el) {
            const $swiperContainer = this.$el.querySelector('.swiper') as HTMLElement;

            if ($swiperContainer && this.$nextButton && this.$prevButton) {
                this.swiper = new Swiper($swiperContainer, {
                    modules: [Navigation],
                    slidesPerView: 1,
                    speed: 500,
                    loop: false,
                    allowTouchMove: false,
                    navigation: {
                        nextEl: this.$nextButton,
                        prevEl: this.$prevButton,
                    },
                });
                this.adjustMarginForQuotes();
            }
        }
    }

    adjustMarginForQuotes(): void {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
        if (!isSafari) return;
        const slidesText = this.$el.querySelectorAll<HTMLElement>('.js-quote-text');

        slidesText.forEach(slide => {
            const text = slide.textContent?.trim() || '';
            if (
                text[0] === ('"') ||
                text[0] === ('“') ||
                text[0] === ('”') ||
                text[0] === ('‘') ||
                text[0] === ('’') ||
                text[0] === ("'") ||
                text[0] === ("«") ||
                text[0] === ("»")
            ) {
                slide.classList.toggle("safari-text-spacing");
            }
        })}
}